import { render, staticRenderFns } from "./ShopShowItem.vue?vue&type=template&id=753b52c8&scoped=true&"
import script from "./ShopShowItem.vue?vue&type=script&lang=js&"
export * from "./ShopShowItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753b52c8",
  null
  
)

export default component.exports